import { plans } from '@/config/constants';
import { isEmpty } from 'lodash';
import { useSelector } from 'react-redux';

export const moduleIds = {
  // keep this in sync with the modules in the database
  // these will be assigned to the modules in the UI
  DASHBOARD_OVERVIEW: 'DASHBOARD_OVERVIEW',
  PRODUCTIVITY_ALERT: 'PRODUCTIVITY_ALERT',
  TIMELINE: 'TIMELINE',
  SCREENSHOTS: 'SCREENSHOTS',
  APP_USAGE: 'APP_USAGE',
  TEAMS_TIMELINE: 'TEAMS_TIMELINE',
  TEAMS_REPORTING: 'TEAMS_REPORTING',
  USER_ATTENDANCE: 'USER_ATTENDANCE',
  TEAM_ATTENDANCE: 'TEAM_ATTENDANCE',
  NOTIFICATIONS: 'NOTIFICATIONS',
  REGULARIZATION: 'REGULARIZATION',
  REQUESTS_REGULARIZATION: 'REQUESTS_REGULARIZATION',
  LEAVE: 'LEAVE',
  LEAVE_REQUESTS: 'LEAVE_REQUESTS',
  PROFILE: 'PROFILE',
  SETTINGS: 'SETTINGS',
  INVOICES: 'INVOICES',
  PROJECTS: 'PROJECTS',
  TASKS: 'TASKS',
  ADD_EMPLOYEE: 'ADD_EMPLOYEE',
  EMPLOYEE_LIST: 'EMPLOYEE_LIST',
  TEAM_LIST: 'TEAM_LIST',
  INVITATIONS: 'INVITATIONS',
};
export const featureIds = {
  // keep this in sync with the modules in the database
  // these will be assigned to the modules in the UI
  SETTINGS_PAGE_INPUTS: 'SETTINGS_PAGE_INPUTS',
};

export const useFeatures = () => {
  const planFeatures = useSelector((state) => state.planFeatures);
  const authState = useSelector((state) => state.auth);
  const { allFeaturesAndModules, plans: featurePlans } = planFeatures;

  const planId = authState?.profile?.subscription?.planId;
  const planKey = plans[planId]?.key;
  if (!planKey) {
    return {
      hasAccess: {
        module: () => true,
        feature: () => true,
      },
    };
  }

  if (isEmpty(allFeaturesAndModules) || isEmpty(featurePlans)) {
    return {
      hasAccess: {
        module: () => false,
        feature: () => false,
      },
    };
  }

  return {
    hasAccess: {
      module: (module) => {
        return featurePlans?.[planKey]?.modules?.[module]?.enabled || false;
      },
      feature: (feature) => {
        return featurePlans?.[planKey]?.features?.[feature]?.enabled || false;
      },
    },
  };
};
